export default __webpack_public_path__ + "static/media/factory__20.0c09d42a.jpg";